<ca-global-spinner data-testid="global-spinner"></ca-global-spinner>
<div class="app-container mat-typography">
    <router-outlet></router-outlet>
</div>
